// src/App.js

import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Import Global Layout Components
import Header from "./components/Header";

// Import all the Page Components
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import BuyerLogin from "./pages/BuyerLogin";
import MediatorLogin from "./pages/MediatorLogin";
import AppsExtensions from "./pages/AppsExtensions";


export default function App() {
  return (
    <Router>
      {/* This wrapper is for the global sticky footer */}
      <div className="app-wrapper"> 
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/buyer" element={<BuyerLogin />} />
            <Route path="/mediator" element={<MediatorLogin />} />
            <Route path="/apps" element={<AppsExtensions />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}